export const name = 'AcceptUserController';

export default function AcceptUserController(
  $gzEULA,
  rnInvitation,
  rnAuthService,
  rnSession,
  rnPreferences,
  rnLocale,
  $analytics,
  $state,
  $stateParams,
  $q,
  $window,
  $translate
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const EVENT_NAME='accept invitation';

  let analyticsEvent;
  let myParams = {};
  let locales;
  let invitationId;

  let vm = this;
  vm.loading = true;
  vm.submitting = false;
  vm.accept = {};

  // controller functions
  vm.submit = submit;
  vm.cancel = cancel;
  vm.go = go;
  vm.openTerms = openTerms;
  vm.openPrivacyStatement = openPrivacyStatement;

  vm.unitTest = {
    getMyParams: function() {return myParams;},
    handleAcceptError: handleAcceptError
  };

  activate();

  ////////////////////////
  function activate() {
    parseParams();
    let promises = [];
    promises.push(getInvitation(invitationId));
    promises.push(getLocales());
    promises.push(getCurrentEulaVersion());
    promises.push(getCurrentPrivacyVersion());
    $q.all(promises).then(() => {
      let locale = _.find(locales, {value: vm.invitation.languageCode});
      if (locale) {
        rnLocale.setLocalePreference(locale);
        $translate.use(locale.value);
      }

      if (vm.invitation.status !== 'Pending') {
        vm.invalid = true;
        vm.invalidKey = 'register.register.Invitation_Error_' + vm.invitation.status;
        vm.invalidActionKey = 'register.register.AcceptUser_Error_Action_General';
        vm.loading = false;
        return;
      }

      let postAuthentication = _.get(myParams, 'data.postAuthentication');
      if (rnAuthService.isAuthenticated() && postAuthentication) {
        $state.go('acceptExistingUser', { invitationId });
      } else {
        if (!vm.accept.hpidId) {
          // User needs to authenticate with HP ID first (creating an account if necessary)
          _.set(myParams, 'invitationId', invitationId);
          _.set(myParams, 'state', 'acceptUser');
          _.set(myParams, 'signout', true);
          $state.go('acceptHpIdSignIn', myParams);
        }

        vm.loading = false;
      }
    }).catch(() => {
      vm.loading = false;
    });
  }

  function parseParams() {
    myParams.data = $stateParams.data;
    if ($stateParams.bu) {
      myParams.bu = $stateParams.bu;
      vm.bu = $stateParams.bu;
    }


    invitationId = $stateParams.invitationId;
    if (!invitationId || invitationId === '') {
      // fall back to what is stored in state data
      invitationId = _.get(myParams, 'data.invitationId', undefined);
    }

    vm.accept.hpidId = $stateParams.hpidId;
  }

  function getInvitation(invitationId) {
    return rnInvitation.getById(invitationId).then((invitation) => {
      vm.invitation = invitation;
    })
      .catch((error) => {
        vm.invalid = true;
        vm.invalidActionKey = 'register.register.AcceptUser_Error_Action_General';
        if (error === 404) {
          vm.invalidKey = 'register.register.Invitation_Error_Retrieve_NotFound';
        }
        else {
          vm.invalidKey = 'register.register.Invitation_Error_Retrieve';
        }
        vm.loading = false;
        return $q.reject();
      });
  }

  function getLocales() {
    return rnLocale.allLocaleOptions().then(options => {
      locales = options;
    });
  }
  function getCurrentEulaVersion() {
    return $gzEULA.getCurrentVersion().then(version => {
      vm.accept.eulaVersion = version;
    });
  }

  function getCurrentPrivacyVersion() {
    return $gzEULA.getPrivacyVersion().then(version => {
      vm.accept.privacyVersion  = version;
    });
  }

  function submit() {
    let url = vm.invitation._links.accept.href;
    vm.submitting = true;
    delete vm.errorKey;

    return rnInvitation.acceptInvitation(vm.accept, url).then((data) => {
      vm.success = true;
      $analytics.setUsername(data.user.userId);
      $analytics.eventTrack(EVENT_NAME, analyticsEvent);
    })
      .catch((error) => {
        handleAcceptError(error);
      })
      .finally(() => {
        vm.submitting = false;
      });
  }

  function handleAcceptError(error) {
    let statusCode = _.get(error, 'smsError.statusCode', -1);

    switch(statusCode) {
      case 404:
        vm.errorKey = 'register.register.Invitation_ErrorCode_NotFound';
        break;
      case 409:
        if (vm.accept.loginName) {
          vm.errorKey = 'register.register.User_Name_Conflict';
          vm.errorValues = [vm.accept.loginName];
        }
        else {
          vm.errorKey = 'register.register.Invitation_ErrorCode_User_Already_Member';
        }
        break;
      case 498:
        vm.errorKey = 'register.register.Invitation_ErrorCode_Expired';
        break;
      default:
        vm.errorKey = 'register.register.Error_Accepting_Invitation';
    }

    // $analytics.exceptionTrack() in the future
    ga('send', 'exception', {
      exDescription: EVENT_NAME + " failed: " + _.get(error, 'smsError.message', 'unknown')
    });
  }

  function cancel() {
    // If we cancel from here we can drop state (myParams)
    $state.go('signin', {signout: true});
  }

  function go() {
    _.set(myParams, 'data.organizationName', vm.invitation.organizationName);
    myParams.forward = true;
    $state.go('signin', myParams);
  }

  function openTerms($event) {
    if ($event) {
      $event.stopPropagation();
    }
    $gzEULA.show();
  }

  function openPrivacyStatement($event){
    if ($event){
      $event.stopPropagation();
    }
    $window.open('http://www.hp.com/go/privacy', 'hp-privacy');
  }
}



// WEBPACK FOOTER //
// ./components/accept/user/accept-user.controller.js